<template>
	<div :class="`notification corner ${corner} ${type}`">
		<div class="notification-close">
			<span class="fas fa-times" @click="close"></span>
		</div>
		<div class="notification-title">{{ title }}</div>
		<div class="notification-content" v-html="text"></div>
	</div>
</template>

<script>
export default {
	name: 'CornerNotification',
	props: {
		text: undefined,
		title: String,
		corner: String,
		type: String
	},
	methods: {
		close () {
			this.$emit('close')
		}
	}
}
</script>

<style lang="scss" scoped>
	.notification.corner {
		position: fixed;
		z-index: 5;
		bottom: 0;
		right: 0;
		max-width: 100vw;
		width: 400px;
		min-height: 60px;
		border-radius: 5px 5px 0 0;
		background-color: #FEFEFE;
		color: #333;
		animation: 1s animate-bottom-up ease-in-out;

		&.warning {
			background-color: #FBF9CE;

			.notification-title {
				border-color: #CCCE60;
			}
		}

		&.error {
			background-color: #FDCECE;

			.notification-title {
				border-color: #D48787;
			}
		}

		&.info {
			background-color: #CEE2FD;

			.notification-title {
				border-color: #8C87D4;
			}
		}

		&.success {
			background-color: #CEFDD5;

			.notification-title {
				border-color: #92C18C;
			}
		}

		&.top-left {
			bottom: unset;
			right: unset;
			top: 0;
			left: 0;
			border-radius: 0 0 5px 5px;
			animation: 1s animate-top-down ease-in-out;
		}

		&.top-right {
			bottom: unset;
			right: 0;
			top: 0;
			left: unset;
			border-radius: 0 0 5px 5px;
			animation: 1s animate-top-down ease-in-out;
		}

		&.bottom-left {
			bottom: 0;
			right: unset;
			top: unset;
			left: 0;
			border-radius: 5px 5px 0 0;
			animation: 1s animate-bottom-up ease-in-out;
		}

		.notification-title {
			padding: 8px 30px 8px 15px;
			border-bottom: 1px solid #CCC;

			&:empty {
				padding: 0;
				border: none;
			}
		}

		.notification-close {
			position: absolute;
			right: 10px;
			top: 5px;
			cursor: pointer;
		}

		.notification-content {
			padding: 8px 15px;
		}

		.notification-title:empty + .notification-content {
			display: grid;
			place-items: center left;
			height: 100%;
			padding-top: 25px;
		}
	}

	@keyframes animate-top-down {
		from {
			transform: translateY(-100%);
		}

		to {
			transform: translateY(0);
		}
	}

	@keyframes animate-bottom-up {
		from {
			transform: translateY(100%);
		}

		to {
			transform: translateY(0);
		}
	}
</style>
